import { useEffect } from 'react';
import { X } from 'lucide-react';
import { useNotas } from './contexto-notas';

/** Recusa ou erro ao gravar nota ou seta (ex.: quem recebeu o post-it não vê o cartão), no rodapé da tela. */
export function AvisoNotas() {
  const aviso = useNotas((s) => s.aviso);
  const dispensar = useNotas((s) => s.dispensarAviso);
  useEffect(() => {
    if (!aviso) return;
    const relogio = setTimeout(dispensar, 10000);
    return () => clearTimeout(relogio);
  }, [aviso, dispensar]);
  if (!aviso) return null;
  return (
    <div className="aviso-envio" role="alert">
      {aviso}
      <button type="button" aria-label="Fechar aviso" onClick={dispensar}>
        <X size={14} aria-hidden />
      </button>
    </div>
  );
}
